<template lang="pug">
.popup
  .popup__close(@click="$emit('close')")
  .popup__head
    slot(name="head")
  .popup__body
    slot(name="body")
  .popup__buttons
    slot(name="buttons")
</template>

<script>
export default {
  name: "Popup",
};
</script>
